module.exports = __webpack_public_path__ + "img/logo_main.42a0d1b7.svg";